import { nextTick } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';

export default defineNuxtPlugin(async ({ vueApp }) => {
    if (process.env.IS_HISTOIRE) {
        // Skip initialization when running in Histoire
        return;
    }
    const { isWebApp } = useDevice();
    const router = useRouter();
    await router.isReady();

    vueApp.use(
        createGtm({
            id: 'GTM-5WVWHDP',
            vueRouter: router,
            defer: true,
            source: '/api/gtm',
            debug: false,
            trackOnNextTick: true,
        })
    );

    router.afterEach(to => {
        nextTick(() => {
            if (isWebApp.value) {
                window.WebAppWebEngageChannel?.postMessage(
                    JSON.stringify({
                        type: 'screen',
                        to: to.name,
                        fullPath: to.fullPath,
                    })
                );
            } else {
                window.webengage?.onReady(() => {
                    window.webengage?.reload();
                    window.webengage?.screen(to.name?.toString() || '', {
                        fullPath: to.fullPath,
                    });
                });
            }
        });
    });
});
